module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAAAXNSR0IArs4c6QAAASVJREFUKBWVkb1OAkEQx2f2gFARbaxsCVaE2JmYy4EVNL6ED6CQUF8tiV9P4CtYURgIuZhY2FGdobahMlTEwK2/XY9IqHSSmf98/GeyO6OSi42igqzXV4QdUW2ItXPwTYrFax2NphueOgfyoWTZE6TjTWELv2jsa5Lcu5yx1iqTHz1ZNRVjOhIE+1Iq1fAHkANqtzYMQ9dQkGbzHDyj8AHhRCeTT1dAHPYhzsEBTQ9gw/CUUxwnd1vkn4yzrdYNdoHWbbtdMXTWXJ7pqccdo3GckZqhKstl1fCUd8/JsqMdrg9tHBucKmqlXJ4ZJr/kxEu2tZf7vzAedwkq6FSHw4X6LYXhMwn38RTtoq9s6kBWqwv+2KOm5CJWm/z7Dr6BCe54f7r0N+dsceevV+r5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/Stop Patch .png
// module id = 314
// module chunks = 7